import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import TechlinkItemShowFactory from './TechlinkItemShowFactory'
import TechlinkCompanyIndex from './TechlinkCompanyIndex/TechlinkCompanyIndex'
import RouteMap from 'assets/RouteMap'

const TechlinkRouter = (props) => {
    const { intl, user } = props
    const { formatMessage } = intl

    const pathname = window.location.pathname.replace(/%C3%A8/g, 'è').replace(/%C3%A9/g, 'é').replace(/\_/g, '-')
    const urlArray = pathname.slice(1).split('/')
    const showSlug = urlArray[2]

    let altLangUrls
    if (showSlug) {
        altLangUrls = {
            current: window.location.href,
            fr: RouteMap.Page(`techlink/${formatMessage({ id: `routes.${props.page}` })}/${showSlug}`, 'fr'),
            en: RouteMap.Page(`techlink/${formatMessage({ id: `routes.${props.page}` })}/${showSlug}`, 'en'),
            nl: RouteMap.Page(`techlink/${formatMessage({ id: `routes.${props.page}` })}/${showSlug}`, 'nl')
        }
    } else {
        altLangUrls = {
            current: window.location.href,
            fr: RouteMap.Page(`techlink/${formatMessage({ id: 'routes.companies' })}/`, 'fr'),
            en: RouteMap.Page(`techlink/${formatMessage({ id: 'routes.companies' })}/`, 'en'),
            nl: RouteMap.Page(`techlink/${formatMessage({ id: 'routes.companies' })}/`, 'nl')
        }
    }

    return (
        <Switch>
            <Route exact path={`/techlink/${formatMessage({ id: 'routes.companies' })}`}>
                <TechlinkCompanyIndex
                    {...props}
                    altLangUrls={altLangUrls}
                    type='company'
                    filterUrl='/api/v1/companies/filter'
                />
            </Route>
            <Route
                path={`/techlink/${formatMessage({ id: 'routes.companies' })}/:itemid/`}
                render={(props) => <>
                    <TechlinkItemShowFactory
                        {...props}
                        altLangUrls={altLangUrls}
                        renderType='company'
                        getAllInfoUrl='/api/v1/companies/get_all_info?id='
                        user={user}
                    />
                </>
                }
            />
            <Route
                path={`/techlink/${formatMessage({ id: 'routes.first-jobs' })}/:itemid/`}
                render={(props) => <>
                    <TechlinkItemShowFactory
                        {...props}
                        altLangUrls={altLangUrls}
                        renderType='job'
                        getAllInfoUrl='/api/v1/first_jobs/get_all_info?id='
                        user={user}
                    />
                </>
                }
            />
            <Route
                path={`/techlink/${formatMessage({ id: 'routes.internships' })}/:itemid/`}
                render={(props) => <>
                    <TechlinkItemShowFactory
                        {...props}
                        altLangUrls={altLangUrls}
                        renderType='job'
                        getAllInfoUrl='/api/v1/internships/get_all_info?id='
                        user={user}
                    />
                </>
                }
            />
            <Route
                path={`/techlink/${formatMessage({ id: 'routes.student-jobs' })}/:itemid/`}
                render={(props) => <>
                    <TechlinkItemShowFactory
                        {...props}
                        altLangUrls={altLangUrls}
                        renderType='job'
                        getAllInfoUrl='/api/v1/student_jobs/get_all_info?id='
                        user={user}
                    />
                </>
                }
            />
        </Switch>
    )
}

export default injectIntl(TechlinkRouter)
